module.exports = __webpack_public_path__ + "img/search-icon.a376ba71.svg";